export default {
      id: "meny-mer-logo-full-color-usage",
      viewBox: "0 0 539 366",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#meny-mer-logo-full-color",
      toString: function () {
        return this.url;
      }
    }